import React from "react";

const SocialLinks = () => {
  return (
    <>
      <a
        href="https://instagram.com/intuza.academy?igshid=YmMyMTA2M2Y="
        target="_blank"
        rel="noreferrer"
      >
        <i className="fab fa-instagram" />
      </a>
      <a href="https://t.me/intuza" target="_blank" rel="noreferrer">
        <i className="fa-brands fa-telegram"></i>
      </a>
    </>
  );
};

export default SocialLinks;
